import type { Map as MapLibreMap } from "maplibre-gl";
import { get } from "@/lib/api-client-v2";

export type PlaceSearchSettings = {
  url: string;
  params?: Record<string, string | number | boolean>;
};

export type PlaceSearchHit = {
  lat: number;
  lon: number;
  displayName: string;
};

type NominatimHit = {
  lat?: string;
  lon?: string;
  display_name?: string;
};

/**
 * Поиск места через backend-прокси Nominatim (`GET /api/v1/search`).
 * Не ходит напрямую в публичный интернет из браузера (closed contour).
 */
export async function searchPlace(
  query: string,
  _settings?: PlaceSearchSettings,
  limit = 1,
): Promise<PlaceSearchHit | null> {
  const q = query.trim();
  if (!q) return null;

  const data = await get<NominatimHit[]>("/search", { q, limit });
  if (!Array.isArray(data) || data.length === 0) return null;

  const first = data[0];
  const lat = Number(first.lat);
  const lon = Number(first.lon);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

  return {
    lat,
    lon,
    displayName: first.display_name || q,
  };
}

/** Несколько результатов геокодера через backend. */
export async function searchPlaces(
  query: string,
  limit = 5,
): Promise<PlaceSearchHit[]> {
  const q = query.trim();
  if (!q) return [];
  const data = await get<NominatimHit[]>("/search", { q, limit });
  if (!Array.isArray(data)) return [];
  const hits: PlaceSearchHit[] = [];
  for (const row of data) {
    const lat = Number(row.lat);
    const lon = Number(row.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) continue;
    hits.push({
      lat,
      lon,
      displayName: row.display_name || q,
    });
  }
  return hits;
}

export function flyToPlace(map: MapLibreMap, hit: PlaceSearchHit, zoom = 14): void {
  map.flyTo({ center: [hit.lon, hit.lat], zoom });
}
